import React from 'react';

import type { Tournament } from '@swf/poker';
import { TournamentCard, useMTTHandleRegister } from '@swf/poker';

const HighlightsItem: React.FC<{ tournament: Tournament; className: string }> = ({
  tournament,
  className
}) => {
  const handleRegisterClick = useMTTHandleRegister(tournament.id);

  return (
    <TournamentCard tournament={tournament} className={className} onClick={handleRegisterClick} />
  );
};

export default HighlightsItem;
